import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { Subscription } from 'rxjs';
import { DataService } from 'src/app/services/data/data.service';

@Component({
    selector: 'app-case-drawer',
    templateUrl: './case-drawer.component.html',
    styleUrls: ['./case-drawer.component.scss'],
    standalone: false
})
export class CaseDrawerComponent implements OnInit, OnDestroy {
  @ViewChild('caseDrawer') caseDrawer: MatDrawer;

  selectedCaseIdSubscription: Subscription;

  selectedCaseId: string;

  constructor(
    private dataService: DataService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.selectedCaseIdSubscription = this.dataService.selectedCase.subscribe(({id}) => {
      if (id) {
        this.selectedCaseId = id;
      }
    });
  }

  ngOnDestroy(): void {
    if (this.selectedCaseIdSubscription) {
      this.selectedCaseIdSubscription.unsubscribe();
    }
  }

  openCaseDrawer() {
    this.caseDrawer.open();
  }

  closeCaseDrawer() {
    this.caseDrawer.close();
  }
}
